/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Codes_BodyInputs */

const en_recovery_codes_body = /** @type {(inputs: Recovery_Codes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only visible now. They get you back in if you lose every device with your passkey.`)
};

const de_recovery_codes_body = /** @type {(inputs: Recovery_Codes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur jetzt sichtbar. Damit kommst du wieder rein, falls du alle Geräte mit Passkey verlierst.`)
};

/**
* | output |
* | --- |
* | "Only visible now. They get you back in if you lose every device with your passkey." |
*
* @param {Recovery_Codes_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_body = /** @type {((inputs?: Recovery_Codes_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_body(inputs)
	return en_recovery_codes_body(inputs)
});